/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAddressBase,
  PersonAddressBaseOptional,
  PersonAddressBaseMetaI,
  PersonAddressBaseTrackedI,
} from "./person-address-base";
import {
  PersonAddressBaseTracked,
  PersonAddressBaseMeta,
} from "./person-address-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPhoneBase,
  PersonPhoneBaseOptional,
  PersonPhoneBaseMetaI,
  PersonPhoneBaseTrackedI,
} from "./person-phone-base";
import {
  PersonPhoneBaseTracked,
  PersonPhoneBaseMeta,
} from "./person-phone-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonReferral,
  PersonReferralOptional,
  PersonReferralMetaI,
  PersonReferralTrackedI,
} from "./person-referral";
import { PersonReferralTracked, PersonReferralMeta } from "./person-referral";

/**
 *
 * @export
 * @interface PersonPublic
 */
export interface PersonPublicOptional {
  /**
   *
   * @type {Array<PersonReferral>}
   * @memberof PersonPublic
   */
  referrals?: PersonReferralOptional[];
  /**
   *
   * @type {Array<PersonPhoneBase>}
   * @memberof PersonPublic
   */
  phones?: PersonPhoneBaseOptional[];
  /**
   *
   * @type {Array<PersonAddressBase>}
   * @memberof PersonPublic
   */
  addresses?: PersonAddressBaseOptional[];
}

export interface PersonPublic extends PersonPublicOptional {
  /**
   *
   * @type {Array<PersonReferral>}
   * @memberof PersonPublic
   */
  referrals?: PersonReferral[];
  /**
   *
   * @type {Array<PersonPhoneBase>}
   * @memberof PersonPublic
   */
  phones?: PersonPhoneBase[];
  /**
   *
   * @type {Array<PersonAddressBase>}
   * @memberof PersonPublic
   */
  addresses?: PersonAddressBase[];
}

export interface PersonPublicTrackedI {
  /**
   *
   * @type {Array<PersonReferral>}
   * @memberof PersonPublic
   */
  referrals?: PersonReferralTrackedI[];
  referralsIsSet: boolean;
  /**
   *
   * @type {Array<PersonPhoneBase>}
   * @memberof PersonPublic
   */
  phones?: PersonPhoneBaseTrackedI[];
  phonesIsSet: boolean;
  /**
   *
   * @type {Array<PersonAddressBase>}
   * @memberof PersonPublic
   */
  addresses?: PersonAddressBaseTrackedI[];
  addressesIsSet: boolean;
}

transformDatesMap.set("PersonPublic", function (model: PersonPublic) {
  const transformDatesreferrals = transformDatesMap.get("PersonReferral");
  if (transformDatesreferrals) {
    model.referrals?.forEach((sub) => {
      transformDatesreferrals(sub);
    });
  }
  const transformDatesphones = transformDatesMap.get("PersonPhoneBase");
  if (transformDatesphones) {
    model.phones?.forEach((sub) => {
      transformDatesphones(sub);
    });
  }
  const transformDatesaddresses = transformDatesMap.get("PersonAddressBase");
  if (transformDatesaddresses) {
    model.addresses?.forEach((sub) => {
      transformDatesaddresses(sub);
    });
  }
});

export type PersonPublicMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  referrals: PropertyMeta<PersonReferralMetaI>;
  //isDate: false
  //isDatetime: false
  phones: PropertyMeta<PersonPhoneBaseMetaI>;
  //isDate: false
  //isDatetime: false
  addresses: PropertyMeta<PersonAddressBaseMetaI>;
}>;

export var PersonPublicMeta: PersonPublicMetaI = {} as PersonPublicMetaI;
PersonPublicMeta = typeMeta("PersonPublic", {
  referrals: propertyMeta("referrals", true, false, false, PersonReferralMeta),
  phones: propertyMeta("phones", true, false, false, PersonPhoneBaseMeta),
  addresses: propertyMeta(
    "addresses",
    true,
    false,
    false,
    PersonAddressBaseMeta,
  ),
});

const metaI = PersonPublicMeta;

registerMeta(() => {});

export class PersonPublicTracked implements PersonPublicTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  referrals__I?: PersonReferralTracked[] = undefined;
  referralsIsSet: boolean = false;
  set referrals(v: undefined | PersonReferralTracked[]) {
    if (v !== undefined) {
      this.referrals__I = v;
      this.referralsIsSet = true;
    } else {
      this.referrals__I = v || undefined;
      this.referralsIsSet = false;
    }
    this.changeTracker = true;
  }
  get referrals() {
    return this.referrals__I;
  }
  phones__I?: PersonPhoneBaseTracked[] = undefined;
  phonesIsSet: boolean = false;
  set phones(v: undefined | PersonPhoneBaseTracked[]) {
    if (v !== undefined) {
      this.phones__I = v;
      this.phonesIsSet = true;
    } else {
      this.phones__I = v || undefined;
      this.phonesIsSet = false;
    }
    this.changeTracker = true;
  }
  get phones() {
    return this.phones__I;
  }
  addresses__I?: PersonAddressBaseTracked[] = undefined;
  addressesIsSet: boolean = false;
  set addresses(v: undefined | PersonAddressBaseTracked[]) {
    if (v !== undefined) {
      this.addresses__I = v;
      this.addressesIsSet = true;
    } else {
      this.addresses__I = v || undefined;
      this.addressesIsSet = false;
    }
    this.changeTracker = true;
  }
  get addresses() {
    return this.addresses__I;
  }
  constructor(config?: PersonPublicOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.referrals?.forEach((a) => a.setIds());

    this.phones?.forEach((a) => a.setIds());

    this.addresses?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonPublicOptional,
    options?: AssignOptions,
  ): PersonPublicTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.referrals && this.referralsApplyFilter(optionsRequired.filter)) {
      this.referrals = config.referrals?.map(
        (a) => new PersonReferralTracked(a, options),
      );
      if (optionsRequired.unassign) this.referralsIsSet = false;
      else this.referralsIsSet = true;
    }
    if (config.phones && this.phonesApplyFilter(optionsRequired.filter)) {
      this.phones = config.phones?.map(
        (a) => new PersonPhoneBaseTracked(a, options),
      );
      if (optionsRequired.unassign) this.phonesIsSet = false;
      else this.phonesIsSet = true;
    }
    if (config.addresses && this.addressesApplyFilter(optionsRequired.filter)) {
      this.addresses = config.addresses?.map(
        (a) => new PersonAddressBaseTracked(a, options),
      );
      if (optionsRequired.unassign) this.addressesIsSet = false;
      else this.addressesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonPublicTrackedI {
    const cloned = {} as PersonPublicTrackedI;
    if (
      this.referralsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.referralsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralsIsSet = true;
      cloned.referrals = this.referrals
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.referralsIsSet = false
    }
    if (
      this.phonesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.phonesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.phonesIsSet = true;
      cloned.phones = this.phones
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.phonesIsSet = false
    }
    if (
      this.addressesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.addressesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.addressesIsSet = true;
      cloned.addresses = this.addresses
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.addressesIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonPublicTrackedI {
    if (!this.referralsApplyFilter(filter)) this.referralsIsSet = false;

    this.referrals?.forEach((a) => a.unassignAll(filter));
    if (!this.phonesApplyFilter(filter)) this.phonesIsSet = false;

    this.phones?.forEach((a) => a.unassignAll(filter));
    if (!this.addressesApplyFilter(filter)) this.addressesIsSet = false;

    this.addresses?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  referralsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicMeta.referrals,
      PersonPublicMeta,
      this.referrals,
      this,
    );
  }
  referralsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralsIsSet && this.referralsApplyFilter(filter)) return true;

    return this.referrals?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  phonesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonPublicMeta.phones, PersonPublicMeta, this.phones, this);
  }
  phonesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.phonesIsSet && this.phonesApplyFilter(filter)) return true;

    return this.phones?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  addressesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicMeta.addresses,
      PersonPublicMeta,
      this.addresses,
      this,
    );
  }
  addressesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.addressesIsSet && this.addressesApplyFilter(filter)) return true;

    return this.addresses?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.referralsIsSetDeep(filter)) return true;
    if (this.phonesIsSetDeep(filter)) return true;
    if (this.addressesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
